import axios from 'axios';
import { API } from '../config';

class MovimentoService {
    getMovimento() {
        return axios.get(API + `/movimentos`)
    }
}

const instanceMovimento = new MovimentoService();
export default instanceMovimento;
